import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import en from './locales/en.json'
import es from './locales/es.json'
import he from './locales/he.json'
import ar from './locales/ar.json'
import th from './locales/th.json'

/**
 * Initializes i18next with translations
 * @returns void
 */
function initTranslations(): void {
  i18n.use(initReactI18next).init({
    resources: {
      en: { translation: en },
      es: { translation: es },
      he: { translation: he },
      ar: { translation: ar },
      th: { translation: th },
    },
    lng: 'en',
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false,
    },
  })
}

initTranslations()

export default i18n
